"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCookieSet = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
const isCookieSet = (cookieKey, cookieValue) => {
  const value = _jsCookie.default.get(cookieKey);
  return Boolean(value && value === cookieValue);
};
exports.isCookieSet = isCookieSet;